import type { BookingRoomStay } from "@/types/domain";

export const roomStayLabel = (stay: Pick<BookingRoomStay, "room"> & { movedOut?: boolean }) =>
  `${stay.room.name}${stay.room.roomNumber ? ` - Room ${stay.room.roomNumber}` : ""}${stay.movedOut ? " (moved out)" : ""}`;
